import * as React from 'react'
import clsx from 'clsx'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { ContactForm } from '../components/ContactForm'
import { FORM_ETA, HELP_LINKS, SUPPORT_HELP_URL } from '../content'
import styles from './Contact.module.css'

export function Contact(): React.ReactElement {
  return (
    <section className={styles.section} id="formulaire">
      <Container className={styles.inner}>
        <div>
          <h2 className={styles.info__title}>Formulaire de contact</h2>
          <p className={styles.eta}>
            <span className={styles.eta__icon} aria-hidden="true">
              <plume.glyphs.stroke.Stopwatch size={15} />
            </span>
            {FORM_ETA}
          </p>

          <div className={clsx(styles.callout, styles.calloutHelp)}>
            <p className={styles.callout__lead}>
              Avez-vous bien regardé le <a href={SUPPORT_HELP_URL}>Centre d'aide</a>&nbsp;?
            </p>
            <p className={styles.callout__label}>Vos questions les plus fréquentes&nbsp;:</p>
            <div className={styles.callout__links}>
              {HELP_LINKS.map((link) => (
                <a key={link.href} href={link.href}>
                  {link.label} <plume.glyphs.stroke.ArrowRight size={11} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <ContactForm />
      </Container>
    </section>
  )
}
